import { SplitTreatments } from "@splitsoftware/splitio-react";
import featureFlagsDictionary from "infrastructure/split/feature-flags-dictionary";
import { BenefitCategory } from "v2/domain/common/entities/BenefitCagetory";
import { translate as t } from "../../../../../infrastructure/translate/localization";
import BenefitCard from "../../BenefitCard";
import { CountryIsoCode } from "../../../../../v2/domain/common/enums/CountryISOCode";
import pensionPlanBenefitImageV2 from "../../../../../assets/img/v2/pension-plan-benefit.png";
import pensionPlanBenefitDisabledImageV2 from "../../../../../assets/img/v2/pension-plan-benefit-disabled.png";

const PensionPlanTab = ({
  selectedTab,
  toggleActive,
  country,
  companyId,
}: {
  selectedTab: {
    id: string;
    pensionPlanProductConfig: any;
    allowedBenefits: any;
  };
  toggleActive: (
    id: string,
    benefit: string,
    isV2: boolean,
    state: any
  ) => void;
  country: CountryIsoCode;
  companyId: string;
}) => {
  return (
    <SplitTreatments
      names={[featureFlagsDictionary.BA_134]}
      attributes={{
        companyId,
        countryISOCode: country,
        benefit: BenefitCategory.PENSION_PLAN,
      }}
    >
      {({ treatments, isReady }) => {
        const isActiveTreatment =
          treatments[featureFlagsDictionary.BA_134].treatment === "on";

        const pensionPlanIsEnabledOnBenefitModel =
          Boolean(selectedTab?.pensionPlanProductConfig?.enabled) &&
          selectedTab.allowedBenefits.includes("pension-plan-benefit");

        const benefitProps =
          isReady && isActiveTreatment
            ? {
                hasV2Screen: true,
                handleSeeMore: () => {
                  window.location.assign(
                    `/v2/benefits/compensation-plan/${selectedTab.id}/pension-plan?tab=information`
                  );
                },
              }
            : {
                tooltipText: t(
                  "benefits-section.retirement-benefit.tooltip-text"
                ),
                warningTooltipText: t(
                  "benefits-section.retirement-benefit.warning-tooltip-text"
                ),
                handleActiveToggle: () =>
                  toggleActive(
                    selectedTab.id,
                    "pension-plan",
                    true,
                    !pensionPlanIsEnabledOnBenefitModel
                  ),
              };

        return (
          <BenefitCard
            title={t("benefits-section.pension-plan-benefit.pension-plan")}
            image={
              pensionPlanIsEnabledOnBenefitModel
                ? pensionPlanBenefitImageV2
                : pensionPlanBenefitDisabledImageV2
            }
            active={pensionPlanIsEnabledOnBenefitModel}
            country={country}
            {...benefitProps}
          />
        );
      }}
    </SplitTreatments>
  );
};

export default PensionPlanTab;
